import React from 'react';
import steam from './assets/steam.png';
import style from './SteamCard.module.less';

export const SteamCard: React.FC = () => {
  return (
    <div className={style.steamCard}>
      <div className={style.wrapper}>
        <div className={style.buttonWrapper}>
          <a className={style.button} href="https://store.steampowered.com/app/2012320/Parallel_Experiment/#game_area_purchase" target='_blank'>
            <div className={style.buttonContent}>
              <div>
                <img src={steam} alt="steam" />
              </div>
              <div className={style.text}>
                Wishlist on Steam
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};
